export {default as default} from './LoadingComponent'
